module.exports = __webpack_public_path__ + "img/circuit.9ba79d0.gif";